import Container, { type ContainerProps } from "@mui/material/Container";

// Now just a wrapper for Container, but we'll keep it in case we want to do some "Global"-ish customization
// Or maybe remove in the future
export function PageContainer(props: ContainerProps) {
  return <Container {...props} />;
}
